import Storage from './../../services/Storage'
import history from './../../services/history'

/**
 * check handle permission
 * @param (permissions.key | array)
 */

const handlePermission = (value) => {
    let userPermission = Storage.get('user')
    if (userPermission && userPermission.permissions) {
        let objectPermissions = userPermission.permissions.split(',')
        if (typeof value === 'string') {
            return objectPermissions.indexOf(value) !== -1;
        }

        let valueLength = value.length;
        let hasPermis = false;
        for (let i = 0; i < valueLength; i++) {
            if (objectPermissions.indexOf(value[i]) !== -1) {
                hasPermis = true;
                break;
            }
        }
        return hasPermis;
    } else {
        return history.push('/orders')
    }
}

export default handlePermission


// WEBPACK FOOTER //
// ./src/containers/app/handlePermission.js